"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AsyncJobModel () {
        return AsyncJobModel;
    },
    get CreateAsyncJobModel () {
        return CreateAsyncJobModel;
    },
    get LaunchSandboxKwargsModel () {
        return LaunchSandboxKwargsModel;
    },
    get UpdateAsyncJobModel () {
        return UpdateAsyncJobModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const LaunchSandboxKwargsModel = _zod.z.object({
    email: _zod.z.string(),
    s3_file: _zod.z.string(),
    company: _zod.z.string(),
    replace_existing: _zod.z.boolean(),
    is_async: _zod.z.boolean()
});
const AsyncJobModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    task_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    request_id: _zod.z.instanceof(_bson.ObjectId).or(_zod.z.null()),
    request_company: _zod.z.instanceof(_bson.ObjectId).or(_zod.z.null()),
    request_user: _zod.z.instanceof(_bson.ObjectId),
    started: _zod.z.boolean(),
    start_time: _zod.z.date().or(_zod.z.null()),
    started_time: _zod.z.date().or(_zod.z.null()).optional(),
    completed: _zod.z.boolean().optional(),
    completed_with_errors: _zod.z.boolean().optional(),
    progress_count: _zod.z.number(),
    progress_total: _zod.z.number(),
    completed_time: _zod.z.date().or(_zod.z.null()).optional(),
    success: _zod.z.boolean().optional(),
    has_progress: _zod.z.boolean().nullish(),
    // TODO: Too many variations at the moment but should be a union of all possible types
    args: _zod.z.array(_zod.z.unknown()),
    kwargs: LaunchSandboxKwargsModel.or(_zod.z.record(_zod.z.string(), _zod.z.unknown())),
    logs: _zod.z.array(_zod.z.unknown()).optional(),
    errors: _zod.z.array(_zod.z.unknown()).optional()
});
const CreateAsyncJobModel = AsyncJobModel.pick({
    _id: true,
    name: true,
    task_id: true,
    request_id: true,
    request_company: true,
    request_user: true,
    started: true,
    start_time: true,
    started_time: true,
    completed: true,
    args: true,
    kwargs: true,
    has_progress: true,
    progress_count: true,
    progress_total: true
});
const UpdateAsyncJobModel = AsyncJobModel.pick({
    progress_count: true,
    completed: true,
    completed_with_errors: true,
    completed_time: true,
    success: true,
    logs: true,
    errors: true
});
